var _metadata, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaltLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.795,
    height: 186.795,
    viewBox: "0 0 186.795 186.795",
    fill: "none",
    id: "svg28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata34"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 159.852,26.953 c -14.1,-14.1 -29.162,-4.974 -38.588,4.452 L 32.22,120.452 c -9.426,9.425 -19.292,23.746 -4.452,38.584 14.84,14.843 29.161,4.975 38.585,-4.451 L 155.399,65.54 c 9.426,-9.427 18.552,-24.489 4.453,-38.587 z",
    fill: "currentColor",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 74.78,23.306 93.635,42.16 112.827,22.968 c 1.303,-1.306 2.626,-2.518 3.957,-3.661 C 114.774,9.167 108.988,0 93.626,0 78.235,0 72.456,9.203 70.457,19.365 c 1.437,1.243 2.871,2.489 4.323,3.941 z",
    fill: "currentColor",
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 112.816,163.359 -19.18,-19.181 -18.845,18.843 c -1.431,1.432 -2.855,2.74 -4.273,3.969 2.161,10.337 8.277,19.805 23.11,19.805 14.872,0 20.98,-9.519 23.127,-19.889 -1.319,-1.135 -2.639,-2.248 -3.939,-3.547 z",
    fill: "currentColor",
    id: "path6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 66.783,69.013 H 30.433 C 17.105,69.013 0,73.212 0,93.15 c 0,14.877 9.522,20.986 19.894,23.132 1.228,-1.418 46.889,-47.269 46.889,-47.269 z",
    fill: "currentColor",
    id: "path8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 167.435,69.981 c -1.15,1.338 -46.907,47.305 -46.907,47.305 h 35.834 c 13.329,0 30.433,-3.149 30.433,-24.136 0,-15.389 -9.2,-21.171 -19.36,-23.169 z",
    fill: "currentColor",
    id: "path10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 78.693,57.081 85.187,50.587 66.344,31.741 C 56.917,22.316 42.598,12.449 27.758,27.289 16.876,38.171 19.293,48.762 25.065,57.36 26.823,57.23 78.693,57.081 78.693,57.081 Z",
    fill: "currentColor",
    id: "path12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m 108.571,129.218 -6.511,6.511 19.194,19.192 c 9.426,9.427 24.488,18.551 38.586,4.453 10.52,-10.521 8.106,-21.571 2.29,-30.423 -1.872,0.135 -53.559,0.267 -53.559,0.267 z",
    fill: "currentColor",
    id: "path14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaltLogo);
export default __webpack_public_path__ + "static/media/malt-logo.49d71982e30f5f7ff59fea0f33176cf4.svg";
export { ForwardRef as ReactComponent };